<template>
    <v-dialog v-model="show" max-width="80%">
        <template v-slot:activator="{ on, attrs }">
            <v-tooltip top>
                <template v-slot:activator="{ on: tipOn, attrs: tipAttrs }">
                    <v-btn
                        v-on="{ ...on, ...tipOn }"
                        v-bind="{ ...attrs, ...tipAttrs }"
                        fab
                        small
                        dark
                        color="primary"
                        class="mb-2 mr-2"
                    >
                        <v-icon>mdi-file-xml-box</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('system.parseKml') }}</span>
            </v-tooltip>
        </template>
        <v-card>
            <v-toolbar color="primary" dark flat>
                <v-toolbar-title class="white--text">{{ $t('system.parseKml') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="close">
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-form ref="form" v-model="formValidated">
                    <v-file-input label="Selecione o arquivo KML" v-model="file" accept="application/kml" />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="white--text" @click="parseKml">{{$t('button.process')}}</v-btn>
                <v-btn color="primary" class="white--text" @click="close">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import EventBus from '@/utils/eventBus';
import apiController from '@/utils/apiController';

export default {
    name: 'ParseKmlDialog',
    data: () => ({
        user: null,
        token: null,
        file: null,
        show: false,
        formValidated: false,
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.token = sessionStorage.getItem('api');
    },
    methods: {
        close() {
            this.show = false;
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
            this.file = null;
        },
        parseKml() {
            if (this.$refs.form) {
                this.$refs.form.validate();
            }
            if (this.formValidated) {
                const formData = new FormData();
                formData.append('kml', this.file);
                formData.append('download', '1');

                apiController.request(apiController.endpoints.parsekml, {
                    data: formData,
                    config: {
                        responseType: 'blob',
                        validateStatus: () => true,
                        timeout: 600000,
                    },
                    silent: true,
                    onSuccess: async (response) => {
                    if (response.status < 200 || response.status >= 300) {
                        let msg = 'Erro ao processar o arquivo KML';
                        try {
                            const text = await response.data.text();
                            const j = JSON.parse(text);
                            if (j.msg) {
                                msg = j.msg;
                            } else if (j.mensagem) {
                                msg = j.mensagem;
                            }
                        } catch (_) {
                            /* keep default */
                        }
                        EventBus.$emit('show-error', { error: msg });
                        this.close();
                        return;
                    }
                    const ct = (response.headers['content-type'] || '').toLowerCase();
                    if (ct.includes('application/json')) {
                        let msg = 'Erro ao processar o arquivo KML';
                        try {
                            const text = await response.data.text();
                            const j = JSON.parse(text);
                            if (j.msg) {
                                msg = j.msg;
                            } else if (j.mensagem) {
                                msg = j.mensagem;
                            }
                        } catch (_) {
                            /* keep default */
                        }
                        EventBus.$emit('show-error', { error: msg });
                        this.close();
                        return;
                    }
                    EventBus.$emit('show-success', { message: "Arquivo KML processado com sucesso" });
                    // Trechos de 2 pontos sao reroteirizados no backend; o que falhou
                    // veio como reta e o contador chega por header (ver CORS exposedHeaders).
                    const rerouteFailed = Number(response.headers['x-merus-kml-reroute-failed'] || 0);
                    if (rerouteFailed > 0) {
                        EventBus.$emit('show-alert', {
                            tipo: 'warning',
                            mensagem: this.$t('routs.alerts.warning.rerouteFailed'),
                        });
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `merusparsedkml-${new Date().toISOString()}.zip`);
                    document.body.appendChild(link);
                    link.click();
                    this.close();
                },
                onError: (error) => {
                    EventBus.$emit('show-error', { error: error });
                    this.close();
                },
                });
            }
        },
    },
}
</script>
<style>
    
</style>